import React from 'react';
import "../LoggedNavigation/LoggedCss.css";
import { ReactComponent as Logo } from '../logo.svg';
import { FaRegEnvelope, FaInstagramSquare, FaTwitter, FaTiktok } from 'react-icons/fa';
import { motion } from 'framer-motion';
import ttt from './ttt.jpeg';

const Info = () => {
  return (
    <div className="formContentDiv" style={{ backgroundColor: "#237878" ,color:"#f8f8f8"  }}>
    <motion.div animate={{ scale: [1.03, 1] }}
                  transition={{ ease: "easeIn", duration: 0.3 }} style={{ 
    height:"100%",
    width:"90%",
    padding:"30px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  }}>
        
        <motion.div whileHover={{ scale: 1.01 }} style={{ color:"#b2d8d8", backgroundColor: 'transparent', textAlign: "center", fontFamily: 'Roboto',fontWeight:700, fontSize: '60px', marginBottom: '5px' }}>
         Attention Visual Info
        </motion.div>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
  <img src={ttt} alt="Gaze tracking illustration" style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }} />
</div>
        <motion.div whileHover={{ scale: 1.01 }} style={{ color:"#f8f8f8", backgroundColor: 'transparent', textAlign: "center", fontFamily: 'Comfortaa',fontWeight:600, fontSize: '40px', marginBottom: '20px' }}>
          About the Application:
        </motion.div>
        
       
        <motion.div whileHover={{ scale: 1.01 }} style={{color:"#b2d8d8" ,fontFamily: 'Roboto, serif', fontWeight: 300, fontSize: '25px', textAlign: "center", marginBottom: '50px' }}>
           Attention Visual is a web-based research tool for studying and practicing visual-spatial attention. It was built as a <a href="https://via.library.depaul.edu/cdm_etd/52/" target="_blank" rel="noopener noreferrer" style={{color: '#f8f8f8', textDecoration: 'underline'}}>master's thesis project at DePaul University's School of Computing</a>, defended in June 2023.<br></br>
<br></br>
The motivation came from a real problem in cognitive science research: traditional studies of visual attention need lab equipment and limit participants to people who can come in physically. A web-based tool with webcam-based gaze tracking lets people take the same tests from home, which makes research more accessible and the data more diverse.<br></br>
<br></br>
The tool uses adaptive difficulty. As your performance improves, the tests get harder. As it drops, they get easier. The idea is that this progressive challenge can help strengthen visual-spatial attention over time.<br></br>
<br></br>
The thesis explored five visual illusion types as test variations: resize, recolor, reshape, rotate, and blink. Each tests a different aspect of how visual attention responds to change.<br></br>
<br></br>
The research suggests this approach has potential applications beyond casual practice, including cognitive training for athletes and people with certain cognitive conditions. The full thesis explores these possibilities in detail.<br></br>
        </motion.div>


        <motion.div whileHover={{ scale: 1.01 }} style={{ color:"#f8f8f8", backgroundColor: 'transparent', textAlign: "center", fontFamily: 'Comfortaa',fontWeight:600, fontSize: '40px', marginBottom: '20px' }}>
          How it Works:
        </motion.div>
        
       
        <motion.div whileHover={{ scale: 1.01 }} style={{color:"#b2d8d8" ,fontFamily: 'Roboto, serif', fontWeight: 300, fontSize: '25px', textAlign: "center", marginBottom: '50px' }}>
Find a well-lit spot for your face. Make sure there are no shadows or glare on the screen.
<br></br><br></br>
Sit about 20-27 inches (50-70 cm) away from the screen, facing it straight on with your eyes looking forward.
<br></br><br></br>
Before you start, the app calibrates to your gaze patterns. It's quick, and the on-screen instructions walk you through it.
<br></br><br></br>
Stay relaxed and comfortable.
<br></br><br></br>
<span style={{fontWeight:500, fontSize:"27px"}}>Calibration:</span>
<br></br><br></br>
You'll see a screen with several points scattered around.
<br></br><br></br>
Click each point with your mouse or tap with your finger. They'll turn gray as you click them.
<br></br><br></br>
Continue clicking until all the points turn gray. That means the calibration is complete.
<br></br><br></br>
Meet Gaze Turtle,&nbsp;<Logo style={{width: '25px', height: '25px'}} /> the icon that shows where you're looking on the screen. After calibration, Gaze Turtle appears and follows your gaze. It can't move as fast as your eyes, but it does its best to keep up.
<br></br><br></br>
<span style={{fontWeight:500, fontSize:"27px"}}>Training session:</span>
<br></br><br></br>
Press the "Start Session" button to begin a 5-minute session.
<br></br><br></br>
Points appear on the screen during the session. As your performance improves, the test gets harder by adding more shapes, more colors, and a denser arrangement of points. Stay focused and watch for the animated point.
<br></br><br></br>
The animated point performs one of five illusion types: resize, recolor, reshape, rotate, or blink. Your goal is to click on it as quickly and accurately as you can.
<br></br><br></br>
Each correct click earns 3 points. Each wrong click costs 1 point. Practicing regularly is how you improve your visual attention and grow your score over time.
<br></br><br></br>
Stay relaxed and focused while you play. Don't forget to breathe.
<br></br><br></br>
Press "Start Session" when you're ready to begin.
        </motion.div>


        <motion.div whileHover={{ scale: 1.01 }} style={{ color:"#f8f8f8", backgroundColor: 'transparent', textAlign: "center", fontFamily: 'Comfortaa',fontWeight:600, fontSize: '40px', marginBottom: '20px' }}>
          Status:
        </motion.div>


        <motion.div whileHover={{ scale: 1.01 }} style={{color:"#b2d8d8" ,fontFamily: 'Roboto, serif', fontWeight: 300, fontSize: '25px', textAlign: "center", marginBottom: '50px' }}>
Attention Visual is the live tool from the master's thesis at DePaul. The site is maintained, and the methodology stays grounded in the original research. If you find a bug or want to share feedback, please email info@attentionvisual.com.
        </motion.div>


        <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", marginBottom: '20px' }}>
  

          
        </div>

      <div style={{
  borderTop: '1px solid #b2d8d8',
  padding: '20px',
  textAlign: 'center',
  fontFamily: 'Roboto Mono',
  fontWeight:400,
}}>
 <div style={{ display: "flex", justifyContent: "center", marginBottom: '20px' }}></div>
<motion.div whileHover={{ scale: 1.02 }} style={{ whiteSpace: 'nowrap', margin: '18px',marginBottom:"5px" }}>
      Contact Us:
    </motion.div>
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '14px', fontFamily: 'Roboto', flexWrap: 'wrap' }}>
    
    <motion.div whileHover={{ scale: 1.08 }} style={{ whiteSpace: 'nowrap', margin: '10px' }}>
      <span><FaRegEnvelope style={{ color: "#D66532", fontSize: "25px" }} /> <a style={{color:"#D66532"}} href="mailto:info@attentionvisual.com">&nbsp;info@attentionvisual.com</a></span>
    </motion.div>
    <motion.div whileHover={{ scale: 1.08 }} style={{ whiteSpace: 'nowrap', margin: '10px' }}>
      <span><FaInstagramSquare style={{ color: "#C13584", fontSize: "25px" }} /> <a style={{color:"#C13584"}} href="https://www.instagram.com/attentionvisual" target="_blank" rel="noreferrer">@attentionvisual</a></span>
    </motion.div>
    <motion.div whileHover={{ scale: 1.08 }} style={{ whiteSpace: 'nowrap', margin: '10px' }}>
      <span><FaTiktok style={{color:"#000000", fontSize:"25px"}}/> <a style={{color:"#000000"}} href="https://www.tiktok.com/@attentionvisual" target="_blank" rel="noopener noreferrer">@attentionvisual</a></span>
    </motion.div>
    <motion.div whileHover={{ scale: 1.08 }} style={{ whiteSpace: 'nowrap', margin: '10px' }}>
      <span><FaTwitter style={{ color: "#1DA1F2", fontSize: "25px" }} /> <a style={{color:"#1DA1F2"}} href="https://www.twitter.com/attentionvisual" target="_blank" rel="noreferrer">@attentionvisual</a></span>
    </motion.div>

    <motion.div whileHover={{ scale: 1.05 }} style={{ whiteSpace: 'nowrap', margin: '18px' }}>
                  <div

                      

                       style={{
                              fontSize: '18px',
                              fontFamily: 'Roboto Mono, serif',
                              fontWeight: '500',
                              color:"f8f8f8"
                             }}

                   
                    >
      <Logo style={{ width: '45px', height: '45px' }} />
      &nbsp;ATTENTION VISUAL&nbsp;
      <Logo
        style={{ width: '45px', height: '45px', transform: 'scaleX(-1)' }}
      />
    </div>
  </motion.div>
  </div>
                  
</div>
       
      </motion.div>
    </div>
  );
};


export default Info;